import React, { useMemo } from 'react';
import icLogoCircle from 'Assets/img/naya_logo_circle_40@2x.png';
import icQuestion from 'Assets/img/ic_question_line_24_primary@2x.png';
import IntlMessages from 'Util/IntlMessages';

const Header = ({ setIsOpenFaq }) => {
  const isActiveTime = useMemo(() => {
    // 영업시간 평일 08:30~17:30
    const now = new Date();
    const day = now.getDay();
    const minutesFromMidnight = now.getHours() * 60 + now.getMinutes();
    const start = 8 * 60 + 30; // 08:30
    const end = 17 * 60 + 30; // 17:30
    if (day >= 1 && day <= 5 && minutesFromMidnight >= start && minutesFromMidnight < end) {
      return true;
    }
    return false;
  }, []);
  return (
    <div className='customer-support-chat-page-header'>
      <div className='customer-support-chat-page-header-left'>
        <img src={icLogoCircle} alt='logo' style={{ width: '40px', height: '40px' }} />
        <div className='customer-support-chat-page-header-left-text'>
          <div className='customer-support-chat-page-header-left-text-title'>
            <IntlMessages id='customer.support.chat.title' />
          </div>
          <div className='customer-support-chat-page-header-left-text-description'>
            {isActiveTime ? <IntlMessages id='customer.support.chat.header.active.time' /> : <IntlMessages id='customer.support.chat.header.inactive.time' />}
          </div>
        </div>
      </div>
      <img
        src={icQuestion}
        alt='question'
        className='cursor-pointer'
        style={{ width: '24px', height: '24px' }}
        onClick={() => {
          setIsOpenFaq(prev => !prev);
          localStorage.setItem('closedFaq', true);
        }}
      />
    </div>
  );
};

export default Header;
